import { MISC_MODAL as $ST } from 'plugins/tfs/platformConfigs/staticTextMaps/packageOrderDetail';
import React, { Component } from 'react';
import { Button } from 'antd';
import Modal from 'components/ui-ant/Feedback/modal';
import Image from 'theme/Image';
import { thumbnailImageUrl } from 'theme/utils';
import '../../main/style.css';

class MiscModal extends Component {
  modalContent = () => {
    const { orderItem } = this.props;

    if (!orderItem) return null;

    const {
      product: { name, dimensions },
      innerFrameNote,
      innerFrameColor,
      outerFrameColor,
      miscImageInfo: { rotate, scale, translateX, translateY },
      miscImageOriginal,
      miscImage,
    } = orderItem;

    return (
      <div className='ant-col-xs-24'>
        <div className='ant-col-xs-12'>
          <div className='image-container'>
            <div className='black-border'>
              <Image
                src={thumbnailImageUrl(miscImageOriginal, 200, 200)}
                width={200}
                height={200}
              />
            </div>
          </div>
        </div>
        <div className='misc-modal ant-col-xs-12'>
          <p>
            <b>{$ST.NAME}: </b>
            {name}
          </p>
          <p>
            <b>{$ST.DIMENSIONS}: </b>
            {dimensions}
          </p>
          <p>
            <b>{$ST.INNER_FRAME_NOTE}: </b>
            {innerFrameNote}
          </p>
          <p>
            <b>{$ST.INNER_FRAME_COLOR}: </b>
            {innerFrameColor}
          </p>
          <p>
            <b>{$ST.OUTER_FRAME_COLOR}: </b>
            {outerFrameColor}
          </p>
          <p>
            <b>{$ST.ROTATE}: </b>
            {rotate}
          </p>
          <p>
            <b>{$ST.SCALE}: </b>
            {scale}
          </p>
          <p>
            <b>{$ST.TRANSLATE_X}: </b>
            {translateX}
          </p>
          <p>
            <b>{$ST.TRANSLATE_Y}: </b>
            {translateY}
          </p>
          <p>
            <a href={miscImageOriginal} target='_blank'>
              {$ST.ORIGINAL_IMAGE}
            </a>
          </p>
          <p>
            <a href={miscImage} target='_blank'>
              {$ST.EDITED_IMAGE}
            </a>
          </p>
        </div>
      </div>
    );
  };

  render() {
    const { visible, onClose } = this.props;

    return (
      <Modal
        className='package-modal'
        visible={visible}
        onCancel={onClose}
        title={$ST.MODAL_TITLE}
        centered
        footer={[
          <Button key='submit' type='primary' onClick={onClose}>
            {$ST.OKAY}
          </Button>,
        ]}
      >
        {this.modalContent()}
      </Modal>
    );
  }
}

export default MiscModal;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderDetail/modals/misc/index.js